import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { V4_API_PREFIX } from '../../api-services.config';
import { IndicatorScore, PaginatedV4Response } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class IndicatorScoresService {
  private readonly http = inject(HttpClient);
  private readonly API_PREFIX = `${V4_API_PREFIX}country/indicator-score/`;

  public getIndicatorScores({
    country_code,
    index_version_id,
  }: {
    country_code: string;
    index_version_id: string;
  }): Observable<PaginatedV4Response<IndicatorScore>> {
    return this.http.get<PaginatedV4Response<IndicatorScore>>(this.API_PREFIX, { params: { country_code, index_version_id } });
  }
}
